<script>
import {useDeviceRevisionsStore} from "@/stores/deviceRevisions.js";
import {mapStores} from "pinia";
import FilterCheckbox from "@/Forms/Filters/FilterCheckbox.vue";

export default {
  name: "FilterDeviceRevisionsTab",
  inheritAttrs: false,
  components: {FilterCheckbox},
  computed: {
    ...mapStores(useDeviceRevisionsStore),
  },
  mounted() {
    console.log(this.$options.name);
    this.deviceRevisionsStore.indexDeviceRevisionOptions();
  },
}
</script>

<template>
  <p class="font-bold text-xl mb-4">Device Revisions</p>
  <div class="card flex flex-wrap justify-content-center gap-3">
    <FilterCheckbox
        v-for="deviceRevision in deviceRevisionsStore.getDeviceRevisionOptions"
        v-bind="$attrs"
        :value="deviceRevision.id"
        :label="deviceRevision.name"
    />
  </div>
</template>

<style scoped>

</style>